import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/images/logo.jpeg";

const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "Contact", href: "/contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isActive = (href) => location.pathname === href;

  return (
    <nav style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 1000,
      background: scrolled ? "rgba(255,255,255,0.97)" : "rgba(255,255,255,0.92)",
      backdropFilter: "blur(12px)",
      borderBottom: scrolled ? "2px solid #1a6ab5" : "2px solid rgba(26,106,181,0.2)",
      boxShadow: scrolled ? "0 2px 20px rgba(26,106,181,0.1)" : "none",
      transition: "all 0.35s ease",
      fontFamily: "'Barlow Condensed', sans-serif",
    }}>
      <link href="https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@400;600;700;800&family=Barlow:wght@400;500;600&display=swap" rel="stylesheet" />
      <div style={{ maxWidth: 1200, margin: "0 auto", padding: "0 24px", display: "flex", alignItems: "center", justifyContent: "space-between", height: 72 }}>

        {/* Logo */}
        <Link to="/" style={{ display: "flex", alignItems: "center", gap: 12, textDecoration: "none" }}>
          <img src={logo} alt="Unique Engineers Logo"
            style={{ height: 52, width: 52, objectFit: "cover", borderRadius: 10 }}
          />
          <div>
            <div style={{ color: "#0d3c6e", fontWeight: 800, fontSize: 16, letterSpacing: 1.5, lineHeight: 1.1, textTransform: "uppercase" }}>Unique Engineers</div>
            <div style={{ color: "#1a6ab5", fontWeight: 600, fontSize: 10, letterSpacing: 2, textTransform: "uppercase" }}>Building Contracting LLC</div>
          </div>
        </Link>

        {/* Desktop Nav */}
        <div style={{ display: "flex", gap: 4, alignItems: "center" }} className="desktop-nav">
          {NAV_LINKS.map((link) => (
            <Link key={link.label} to={link.href}
              style={{
                color: isActive(link.href) ? "#1a6ab5" : "#3a6080",
                textDecoration: "none",
                fontWeight: isActive(link.href) ? 700 : 600,
                fontSize: 13, letterSpacing: 1.2, textTransform: "uppercase",
                padding: "8px 12px", borderRadius: 4,
                borderBottom: isActive(link.href) ? "2px solid #1a6ab5" : "2px solid transparent",
                transition: "color 0.2s, background 0.2s",
              }}
              onMouseEnter={e => { if (!isActive(link.href)) { e.currentTarget.style.color = "#1a6ab5"; e.currentTarget.style.background = "rgba(26,106,181,0.08)"; }}}
              onMouseLeave={e => { if (!isActive(link.href)) { e.currentTarget.style.color = "#3a6080"; e.currentTarget.style.background = "transparent"; }}}
            >{link.label}</Link>
          ))}
        </div>

        {/* Hamburger */}
        <button onClick={() => setMenuOpen(!menuOpen)}
          style={{ display: "none", background: "none", border: "none", color: "#1a6ab5", fontSize: 28, cursor: "pointer", padding: 4 }}
          className="hamburger"
        >{menuOpen ? "✕" : "☰"}</button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div style={{ background: "#fff", borderTop: "1px solid rgba(26,106,181,0.15)", padding: "16px 24px 24px" }}>
          {NAV_LINKS.map((link) => (
            <Link key={link.label} to={link.href} onClick={() => setMenuOpen(false)}
              style={{ display: "block", color: isActive(link.href) ? "#1a6ab5" : "#3a6080", textDecoration: "none", fontWeight: 600, fontSize: 15, letterSpacing: 1.5, textTransform: "uppercase", padding: "12px 0", borderBottom: "1px solid rgba(26,106,181,0.08)" }}
            >{link.label}</Link>
          ))}
        </div>
      )}
      <style>{`@media(max-width:900px){.desktop-nav{display:none!important}.hamburger{display:block!important}}`}</style>
    </nav>
  );
}